import { render } from "./Lang.vue?vue&type=template&id=062792fe&scoped=true&ts=true"
import script from "./Lang.vue?vue&type=script&lang=ts"
export * from "./Lang.vue?vue&type=script&lang=ts"

import "./Lang.vue?vue&type=style&index=0&id=062792fe&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-062792fe"]])

export default __exports__